'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../..');

var _2 = _interopRequireDefault(_);

var _Link = require('material-ui-icons/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactRouterDom = require('react-router-dom');

var _ListView = require('../Connectors/Connector/ListView');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Link = (_temp = _class = function (_EditorComponent) {
  _inherits(Link, _EditorComponent);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  }

  Link.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, _react2.default.createElement(_Link2.default, null), ' Link'));
  };

  Link.prototype.getRootElement = function getRootElement() {
    return _reactRouterDom.Link;
  }; // prepareDragItemComponents() {
  //   return super.prepareDragItemComponents().concat([
  //     {
  //       name: "Tag",
  //       component: "Tag",
  //       props: {
  //         tag: "span",
  //       },
  //       components: [],
  //     }
  //   ]);
  // }
  // getRenderProps() {
  //   let renderProps = super.getRenderProps();
  //   // let test = <ObjectContext.Consumer>
  //   //   {context => {
  //   //     {/* return content; */}
  //   //   }}
  //   // </ObjectContext.Consumer>
  //   return renderProps;
  // }


  Link.prototype.renderMainView = function renderMainView() {
    var _this2 = this;

    var object = this.getObjectWithMutations(); // const {
    // } = this.props;

    var _getComponentProps = this.getComponentProps(this),
        to = _getComponentProps.to,
        native = _getComponentProps.native,
        props = _objectWithoutProperties(_getComponentProps, ['to', 'native']); // let content = super.renderMainView();;


    if (to) {
      /**
       * Проверяем есть ли параметры в УРЛ
       */
      var segments = to.split("/");
      /**
       * Если есть, то нам надо обернуть вывод в контекст объекта
       */

      if (segments.find(function (n) {
        return n && n.startsWith(":");
      })) {
        return _react2.default.createElement(_ListView.ObjectContext.Consumer, null, function (context) {
          var object = context.object;

          if (object) {
            to = segments.map(function (n) {
              if (n && n.startsWith(":")) {
                n = object[n.replace(/^\:/, '')];
              }

              return n;
            }).join("/");
          }

          return _EditorComponent.prototype.renderMainView.call(_this2, {
            to: to
          });
        });
      }
    }

    return _EditorComponent.prototype.renderMainView.call(this);
  }; // getRenderProps() {
  //   const {
  //     style,
  //     marginTop,
  //     marginBottom,
  //     // props: {
  //     //   ...otherProps
  //     // },
  //     ...other
  //   } = super.getRenderProps();
  //   // const {
  //   //   text,
  //   //   // type,
  //   //   // style,
  //   //   color,
  //   //   display,
  //   //   displayType,
  //   //   ...otherProps
  //   // } = this.getComponentProps(this);
  //   const renderProps = {
  //     style: {
  //       ...style,
  //       marginTop,
  //       marginBottom,
  //     },
  //     ...other,
  //     // ...otherProps
  //   }
  //   return renderProps;
  // }
  // renderMainView() {
  //   // const {
  //   //   marginTop,
  //   //   marginBottom,
  //   // } = this.getComponentProps(this);
  //   const {
  //     style,
  //     marginTop,
  //     marginBottom,
  //     ...other
  //   } = this.getRenderProps();
  //   return <div
  //     style={{
  //       marginTop,
  //       marginBottom,
  //       ...style,
  //     }}
  //     {...other}
  //   >
  //     {super.renderMainView()}
  //   </div>;
  // }


  return Link;
}(_2.default), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  // native: false,
  to: "",
  target: ""
}), _class.Name = "Link", _temp);
exports.default = Link;
module.exports = exports['default'];